/**
 * ページ内リンクなどのスムーススクロール用jsになります。
 * header: '#header'は、headerの高さ分を考慮してアンカーリンクの処理を実行する為の設定です。
 * speedAsDurationがfalseだと、伸びるようなeasingになってしまうので、trueに設定して等速にしています。
 * updateURLがtrueだと、ページ内遷移をしたさいurlに#〇〇が付与されます。falseだとurlには何もつきません。（なお、別ページの指定箇所へ飛ぶ場合はurlに#〇〇が付いてしまうみたいです）
 */

import smoothscroll from 'smoothscroll-polyfill';
import SmoothScroll from 'smooth-scroll';

export function smooth() {
  smoothscroll.polyfill();

  const scroll = new SmoothScroll('a[href*="#"]', {
    header: '.l-header',
    speed: 300,
    speedAsDuration: true,
    updateURL: false,
  });
}
